import { render, staticRenderFns } from "./PromotionType.vue?vue&type=template&id=28dc0c92&"
import script from "./PromotionType.vue?vue&type=script&lang=ts&"
export * from "./PromotionType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports